export default function DeleteIcon({ color = "currentColor" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M8.68777 7.3125V11.8125M5.31278 7.3125V11.8125M13.1875 3.9375L0.8125 3.9375M12.0628 3.9375V14.625C12.0628 14.7742 12.0035 14.9173 11.898 15.0227C11.7925 15.1282 11.6495 15.1875 11.5003 15.1875H2.50028C2.35109 15.1875 2.20802 15.1282 2.10253 15.0227C1.99704 14.9173 1.93778 14.7742 1.93778 14.625V3.9375M9.81277 3.9375V2.8125C9.81277 2.51413 9.69425 2.22798 9.48327 2.017C9.27229 1.80603 8.98614 1.6875 8.68777 1.6875H5.31278C5.01441 1.6875 4.72826 1.80603 4.51728 2.017C4.3063 2.22798 4.18778 2.51413 4.18778 2.8125V3.9375"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
